import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const DispatchOrderRouteMiddleware = ({ fallbackPath }) => {
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));

  if (
    permissions.dispatch_order_create === true ||
    permissions.dispatch_order_edit === true ||
    permissions.dispatch_order_view === true
  ) {
    return <Outlet />;
  } else {
    return <Navigate to={fallbackPath} />;
  }
};

export default DispatchOrderRouteMiddleware;
